import {
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Observer, from } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { pingBaseUrl } from '../service/api/ping-api-service';
import { OfflineKeycloakService } from '../service/keycloak.service';

const excludedUrls = [pingBaseUrl];
@Injectable({ providedIn: 'root' })
export class BearerTokenInterceptor implements HttpInterceptor {
  constructor(private keycloakService: OfflineKeycloakService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (excludedUrls.includes(req.url)) {
      return next.handle(req);
    }

    return from(this.keycloakService.isAuthenticated()).pipe(
      mergeMap((authenticated) => {
        if (!authenticated) {
          return next.handle(req);
        }

        return this.addTokenToHeader(req, next, req.headers).pipe(
          mergeMap((headersWithToken) => {
            const newReq = req.clone({ headers: headersWithToken });
            return next.handle(newReq);
          }),
        );
      }),
    );
  }

  private addTokenToHeader(
    req: HttpRequest<any>,
    next: HttpHandler,
    headers: HttpHeaders = new HttpHeaders(),
  ): Observable<HttpHeaders> {
    return new Observable((observer: Observer<HttpHeaders>) => {
      this.keycloakService
        .getToken()
        .then((token) => {
          observer.next(headers.set('Authorization', 'bearer ' + token));
          observer.complete();
        })
        .catch(() => {
          observer.next(headers);
          observer.complete();
        });
    });
  }
}
